import React from "react";
import {
  SCROLL_OFFSET,
  ARTICLE_COLUMN,
  H2,
  BODY,
  STACK_GAP,
} from "./sections";

const MacComparisonSection = () => {
  return (
    <section
      id="mac-dictation-vs-ai-voice-typing"
      style={{ scrollMarginTop: `${SCROLL_OFFSET}px` }}
      className={ARTICLE_COLUMN}
    >
      <h2 className={H2}>Mac Dictation vs AI Voice Typing</h2>

      <p className={`${STACK_GAP} ${BODY}`}>
        Mac Dictation is fast to trigger and handles short bursts of speech
        reasonably well. It falls apart in the same place Windows does: longer
        sessions, technical vocabulary, and anything that needs restructuring
        rather than just transcribing.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        There&apos;s also no persistent memory of how you spell a client&apos;s
        name, a product term, or industry shorthand. You correct it once, and
        it forgets by the next sentence. An AI voice typing tool with a
        Personal Dictionary only needs that correction once, and it stays
        consistent everywhere you dictate afterward, not just in one document.
      </p>

      <p className={`${STACK_GAP} ${BODY}`}>
        For professionals who dictate case notes, client updates, or technical
        content regularly (healthcare, law, content creation are common
        cases), that repeated correction adds up to real time lost every week.
      </p>
    </section>
  );
};

export default MacComparisonSection;
